/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ApiConfig} from '../../api';
import {Uuid} from '../../../util/uuid';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the EarningsAccount HTTP resource (factory product). */
export class EarningsAccountResource {
}

export function createEarningsAccountResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const EarningsAccount: any = createAdnHttpResource(send, 'earningsaccounts', () => localUserProfile);
  const uri = ApiConfig.obtain().getVersionedUri('earningsaccounts');
  const withId = (id: any) => uri + '/' + encodeURIComponent(id);

  EarningsAccount.getApprovalNotifications = function(params: any): any {
    return {$promise: send({method: 'GET', url: withId(params.id) + '/approvalnotifications'})};
  };
  EarningsAccount.acknowledgeApprovalNotifications = function(params: any, data: any): any {
    return {$promise: send({method: 'POST', url: withId(params.id) + '/approvalnotifications/acknowledge', body: data})};
  };
  EarningsAccount.recordApproval = function(params: any, data: any): any {
    return {$promise: send({method: 'POST', url: withId(params.id) + '/approve', body: data})};
  };
  EarningsAccount.getApprovalHistory = function(params: any, data: any): any {
    return {
      $promise: send({
        method: 'POST',
        url: withId(params.id) + '/approvalhistory',
        params: _.omit(params, 'id'),
        body: data
      })
    };
  };
  EarningsAccount.create = function(defaults: any): any {
    return new EarningsAccount(_.merge({id: Uuid.generate()}, defaults));
  };

  return EarningsAccount;
}

export const earningsAccountResourceProvider = {
  provide: EarningsAccountResource,
  useFactory: createEarningsAccountResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

